import React, {useContext} from 'react';
import Field from "./Field";
import FormGroup from "./FormGroup";
import {GlobalContext} from "../context/GlobalProvider";

const Servis = () => {
    const {
        state: {form, errors},
        dispatch,
    } = useContext(GlobalContext);

    const handleChange = (e, name) => {
        const value = e.target.value;
        const newFormData = {
            ...form,
            [name]: value
        }

        dispatch({
            type: 'UPDATE_ISSUE',
            payload: newFormData
        })
    }
    return (
        <div>
            <Field
                onChange={(e) => handleChange(e, 'name')}
                value={form.name}
                name="name"
                label="Vor- und Nachname*"
                required={true}
                error={errors['form.name']}
            />

            {/*<Field*/}
            {/*    onChange={(e) => handleChange(e, 'surname')}*/}
            {/*    value={form.surname}*/}
            {/*    name="surname"*/}
            {/*    placeholder="Nachname"*/}
            {/*    required={true}*/}
            {/*    error={errors['form.surname']}*/}
            {/*/>*/}

            <Field
                onChange={(e) => handleChange(e, 'invoice_number')}
                value={form.invoice_number}
                name="invoice_number"
                label="Rechnungsnummer"
                required={true}
                error={errors['form.invoice_number']}
            />

            <Field
                onChange={(e) => handleChange(e, 'email')}
                value={form.email}
                name="email"
                label="E-Mail*"
                required={true}
                error={errors['form.email']}
            />

            <Field
                onChange={(e) => handleChange(e, 'phone')}
                value={form.phone}
                name="phone"
                label="Telefon*"
                required={true}
                error={errors['form.phone']}
            />

            <Field
                onChange={(e) => handleChange(e, 'street')}
                value={form.street}
                name="street"
                label="Straße*"
                required={true}
                error={errors['form.street']}
            />

            <div className="flex flex-col md:flex-row gap-4">
                <Field
                    onChange={(e) => handleChange(e, 'city')}
                    value={form.city}
                    name="city"
                    label="Stadt*"
                    required={true}
                    error={errors['form.city']}
                    className="w-full md:w-2/3"
                />

                <Field
                    onChange={(e) => handleChange(e, 'zip')}
                    value={form.zip}
                    name="zip"
                    label="PLZ*"
                    required={true}
                    error={errors['form.zip']}
                    className="w-full md:w-1/3"
                />
            </div>
        </div>
    );
};

export default Servis;
